// extracted by css-extract-rspack-plugin
module.exports =  {"button":"Viewer__button--wEl8w","buttonEdit":"Viewer__buttonEdit--X1PX4 Viewer__button--wEl8w","buttonIcon":"Viewer__buttonIcon--Tc4CE"};